import React from "react";
import "./style.css";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { useLocation, useNavigate } from "react-router-dom";

const DesktopSideBar = () => {
  const igniteLogoImage = require("./../assets/images/igniteLogo.png");
  const location = useLocation();
  const navigate = useNavigate();
  const currentRoute = location.pathname;

  return (
    <div className="sideBarMain">
      <div className="igniteLogoDiv">
        <img src={igniteLogoImage} alt="" />
      </div>

      <div className="igniteLinks">
        <div className="home" onClick={() => navigate("/")}>
          <HomeRoundedIcon className="igniteLinkIcon" />
          <span
            style={{
              color: currentRoute === "/" ? "" : "#2B3674",
            }}
          >
            Dashboard
          </span>
          <span className={currentRoute === "/" ? "purpleBar" : ""}></span>
        </div>
      </div>
    </div>
  );
};

export default DesktopSideBar;
